import {
  GET_MY_MACROS,
  GET_MY_MACROS_ERROR,
  GET_SINGLE_MACRO,
  GET_SINGLE_MACRO_ERROR,
  RESET_MACROS_DATA,
  UPDATE_MACRO_EVENT_SERVINGS,
  UPDATE_MACRO_EVENT_SERVINGS_ERROR,
  GET_RECIPE_HISTORY,
  SET_RECIPE_HISTORY,
  RECIPE_HISTORY_ERROR,
  POST_MACRO_EVENT_SERVINGS,
  REMOVE_MACRO_EVENT,
  SET_MY_MACROS,
  SET_SINGLE_MACRO,
} from "../actions/types";

const initialState = {
  macrosData: null,
  macrosDataLoading: true,
  macrosDataError: false,
  currentDate: null,
  singleMacroData: null,
  singleMacroDataLoading: true,
  singleMacroDataError: false,
  servingsUpdateLoading: false,
  servingsUpdateError: null,
  recipeHistory: null,
  recipeHistoryDate: null,
  recipeHistoryLoading: true,
  recipeHistoryError: false,
};

export default function (state = initialState, action) {
  //Destructure action
  const { type, payload } = action;

  switch (type) {
    case GET_MY_MACROS:
      return {
        ...state,
        macrosData: null,
        macrosDataLoading: true,
        macrosDataError: false,
        currentDate: null,
      };
    case SET_MY_MACROS:
      return {
        ...state,
        macrosData: payload.data,
        macrosDataLoading: false,
        macrosDataError: false,
        currentDate: payload.date,
      };
    case GET_MY_MACROS_ERROR:
      return {
        ...state,
        macrosData: null,
        macrosDataLoading: false,
        macrosDataError: true,
      };
    case GET_SINGLE_MACRO:
      return {
        ...state,
        singleMacroData: null,
        singleMacroDataLoading: true,
        singleMacroDataError: false,
      };
    case SET_SINGLE_MACRO:
      return {
        ...state,
        singleMacroData: payload.data,
        singleMacroDataLoading: false,
        singleMacroDataError: false,
      };
    case GET_SINGLE_MACRO_ERROR:
      return {
        ...state,
        singleMacroData: null,
        singleMacroDataLoading: false,
        singleMacroDataError: true,
      };
    case POST_MACRO_EVENT_SERVINGS:
      return {
        ...state,
        servingsUpdateLoading: true,
        servingsUpdateError: false,
      };
    case UPDATE_MACRO_EVENT_SERVINGS:
      return {
        ...state,
        recipeHistory: state.recipeHistory.map((history, index) =>
          index === payload.historySectionIndex
            ? {
                ...history,
                macros: {
                  ...history.macros,
                  sections: history.macros.sections.map((section, index) =>
                    index === payload.macroSectionIndex
                      ? {
                          ...section,
                          servingsEaten: payload.servingsEaten,
                        }
                      : section
                  ),
                },
              }
            : history
        ),
        servingsUpdateLoading: false,
        servingsUpdateError: null,
      };
    case UPDATE_MACRO_EVENT_SERVINGS_ERROR:
      return {
        ...state,
        servingsUpdateError: payload,
        servingsUpdateLoading: false,
      };
    case RESET_MACROS_DATA:
      return initialState;
    case GET_RECIPE_HISTORY:
      return {
        ...state,
        recipeHistory: null,
        recipeHistoryDate: null,
        recipeHistoryLoading: true,
        recipeHistoryError: false,
        currentDate: null,
      };
    case SET_RECIPE_HISTORY:
      return {
        ...state,
        recipeHistoryDate: payload.date,
        recipeHistory: payload.data,
        recipeHistoryLoading: false,
        recipeHistoryError: false,
      };
    case RECIPE_HISTORY_ERROR:
      return {
        ...state,
        recipeHistory: null,
        recipeHistoryLoading: false,
        recipeHistoryDate: null,
        recipeHistoryError: true,
        currentDate: null,
      };

    case REMOVE_MACRO_EVENT:
      return {
        ...state,
        recipeHistory: payload,
      };
    default:
      return state;
  }
}
